import styled from 'styled-components';

export const SectionHeader = styled.h5`
    font-size: .9rem;
    font-weight: bold;
    letter-spacing: 1px;
    line-height: 1rem;
    text-align: center;
    color: #2E2E33;
`;



// WEBPACK FOOTER //
// ./src/components/Heading/SectionHeader.js